export const ERRORS_CODE = {
  ERR_PHONE: 'UREG_ERR_146',
  ERR_AUTH: 'AUTH_ERR_101',
};

export const ERR_GENERIC = {
  message: 'Something went wrong. Please refresh the page and try again.',
};

export const ERR_GENERIC_LATER = {
  message: 'Something went wrong on our end. Please check back later.',
};

export const ERR_PHONE = {
  message:
    'This phone number is associated with another account. Please try another number.',
};

export const ERR_INVALID_ZIP = {
  message: 'Please provide a valid zip code.',
};

export const ERR_SAVE = {
  message: 'We’re unable to save your changes. Please try again.',
};

export const ERR_REDIRECT = {
  message: 'We’re redirecting you to sign in to your account.',
};

export const ERR_FILTER = {
  message:
    'We were unable to load your filters. Refresh your page and try again.',
};
